import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Edit2, Trash2, Check, X } from "lucide-react";

interface ChatListItemProps {
  id: string;
  title: string;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
  onRename: (id: string, newTitle: string) => void;
}

export function ChatListItem({
  id,
  title,
  onSelect,
  onDelete,
  onRename,
}: ChatListItemProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [newTitle, setNewTitle] = useState(title);

  const handleRename = () => {
    if (newTitle.trim() !== "") {
      onRename(id, newTitle);
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <div className="flex items-center gap-2 p-2 hover:bg-accent">
        <Input
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
          className="flex-1"
          autoFocus
        />
        <Button
          variant="ghost"
          size="icon"
          onClick={handleRename}
          className="h-8 w-8"
        >
          <Check className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => {
            setIsEditing(false);
            setNewTitle(title);
          }}
          className="h-8 w-8"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    );
  }

  return (
    <div className="group flex items-center gap-2 p-2 hover:bg-accent rounded-md">
      <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setIsEditing(true)}
          className="h-8 w-8"
        >
          <Edit2 className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onDelete(id)}
          className="h-8 w-8 text-destructive hover:text-destructive hover:bg-destructive/10"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
      <Button
        variant="ghost"
        className="flex-1 justify-start font-normal"
        onClick={() => onSelect(id)}
      >
        {title}
      </Button>
    </div>
  );
}